import { formatCurrency } from 'modules/I18N';
import { CurrencyRendererProps } from './CurrencyRenderer.types';

const CurrencyRenderer = ({ value, currencyCode, localeCode }: CurrencyRendererProps): string | null =>
  value === null ? null : formatCurrency({ value, localeCode, currencyCode });

export default CurrencyRenderer;
